import { format, parseISO } from 'date-fns';

/**
 * Return Date String for with yyyy-MM-dd format
 * @param {Date} date
 * @returns {string} yyyy-MM-dd, i.e. 2020-12-24
 */
export const formatDate = (date: string): string => {
  const parsedDate = parseISO(date);

  return format(parsedDate, 'yyyy-MM-dd');
};
